<template>
	<div>
		<CLoader :pConfigLoad="ConfigLoad">
			<template slot="BodyFormLoad">
				<!-- <div class="form-group row">
					<div class="col-lg-2 mt-3">
						<div class="form-check form-check-inline">
							<label class="check_box m-0 pl-4">
            					<input v-model="contract.ContratoMaster" type="checkbox" class="form-check-input">
            					<span class="checkmark" style="border:2px solid #bababa;"></span>
            				</label>
							<span class="bold">Contrato Master</span>
						</div>
					</div>
					<div class="col-lg-3" v-if="contract.ContratoMaster && contract.IdClienteS!=''">
						<label>Contrato Master</label>
						<select v-model="contract.IdContratoMaster" class="form-control">
							<option value="">-Contrato-</option>
							<option v-for="(item,index) in ListaContratosMaster" :value="item.IdContrato" :key="index">{{item.NumeroC}}</option>
						</select>
					</div>
				</div>
				<hr> -->
				<div class="form-group row">
					<div class="col-lg-3">
						<label for="">Propuesta *</label>
						<select v-model="contract.IdPropuesta" class="form-control" @change="ValoresPropuesta()">
							<option value="">-Propuesta-</option>
							<option v-show="contract.IdClienteS!=''" value="crear">Crear Propuesta</option>
							<option value="0">Sin Propuesta</option>
							<option v-for="(item,index) in ListaPropuestas" :value="item.IdPropuesta" :key="index">{{item.Numero}}</option>
						</select>
						<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.IdPropuesta" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
					</div>
		
					<div class="col-lg-2">
						<label>Tipo de Contrato *</label>
						<select v-model="contract.TipoContrato" class="form-control" v-if="['','Orden de Compra','Aprobación Verbal','Cotización','Email','Website','WhatsApp'].includes(contract.TipoContrato)">
							<option value="">-Tipo Contrato-</option>
							<option value="Orden de Compra">Orden de Compra</option>
							<option value="Aprobación Verbal">Aprobación Verbal</option>
							<option value="Cotización">Cotización</option>
							<option value="Email">Email</option>
							<option value="Website">Website</option>
							<option value="WhatsApp">WhatsApp</option>
						</select>
						<input v-else v-model="contract.TipoContrato" class="form-control" placeholder="Tipo de Contrato"/>
						<label id="lblmsuser" style="color:red"
							><Cvalidation v-if="this.errorvalidacion.TipoContrato" :Mensaje="errorvalidacion.TipoContrato[0]"></Cvalidation
						></label>
					</div>
					<div class="col-lg-2">
						<label for="">Tipo de Servicio *</label>
						<select :disabled="DisableCampos" v-model="contract.IdConfigS" class="form-control" name="" id="" @change="ListaSubtipo();SetCasillaSpendPlan()">
							<option value="">Selecciona una opción</option>
							<option v-for="(lista,index) in ListaTipoServicio" :value=lista.IdConfigS :key="index">
								{{ lista.Nombre }}
							</option>
						</select>
						<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.IdConfigS" :Mensaje="errorvalidacion.IdConfigS[0]" ></Cvalidation
						></label>
					</div>
					<div class="col-lg-3">
						<label for="">SubTipo de Servicio *</label>
						<select v-model="contract.IdTipoSer" class="form-control" name="" id="">
							<option value="">Selecciona una opción</option>
							<option v-for="(lista,index) in ListaSubTipoServicio" :value=lista.IdTipoSer :key="index">
								{{ lista.Concepto }}
							</option>
						</select>
						<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.IdTipoSer" :Mensaje="errorvalidacion.IdTipoSer[0]" ></Cvalidation
						></label>
					</div>
					<div class="col-lg-2">
						<label>Valor Propuesta *</label>
						<vue-numeric @paste="SugerenciaPegado" @input="SugerenciaVenta" :disabled="DisableCampos" class="form-control " currency="$" separator="," placeholder="$0" :precision="0" v-model="contract.ValorPropuesta"></vue-numeric>
						<label id="lblmsuser" style="color:red"
							><Cvalidation v-if="this.errorvalidacion.ValorPropuesta" :Mensaje="errorvalidacion.ValorPropuesta[0]"></Cvalidation
						></label>
					</div>
				</div>
		
				<div class="form-group row">
					<div class="col-lg-2">
						<label>Valor Venta *</label>
						<vue-numeric
								class="form-control "
								currency="$"
								separator=","
								placeholder="$0"
								:precision="0"
								v-model="contract.Valor"
							></vue-numeric>
						<label id="lblmsuser" style="color:red" ><Cvalidation v-if="this.errorvalidacion.Valor" :Mensaje="errorvalidacion.Valor[0]"></Cvalidation></label>
					</div>
					<!-- <div class="col-lg-2">
						<label>Gross Profit *</label>
						<Cporcentaje 
							:activo="false" 
							:minus="true" 
							:clase="'form-control'"
							  currency="%" 
							  separator="," 
							  :precision="2" 
							@input="LimitarGrossProfit"
							  v-model="contract.GrossProfit"/>
							  <label id="lblmsuser" style="color:red" ><Cvalidation v-if="this.errorvalidacion.GrossProfit" :Mensaje="errorvalidacion.GrossProfit[0]"></Cvalidation></label>
					</div> -->
					<div class="col-lg-2">
						<label>Cantidad de Pagos *</label>
						<select @change="SetListaDetalles" v-model="contract.Facturacion" class="form-control" name="" id="">
							<option value="">Selecciona una opción</option>
							<option value="1">1 Pago</option>
							<option value="2">2 Pagos</option>
							<option value="3">3 Pagos</option>
							<option value="4">4 Pagos</option>
							<option value="5">Estimados</option>
							<option value="Mensual">Mensual</option>
							<option value="Bimestral">Bimestral</option>
							<option value="Trimestral">Trimestral</option>
						</select>
						<!-- <input v-model="contract.Facturacion" class="form-control" placeholder="Facturación"/> -->
						<label id="lblmsuser" style="color:red"
							><Cvalidation v-if="this.errorvalidacion.Facturacion" :Mensaje="errorvalidacion.Facturacion[0]"></Cvalidation
						></label>
					</div>
					<div class="col-lg-2" style="flex-basis:13%">
						<label>Venta *</label>
						<v-date-picker v-model="contract.FechaVenta" :mode="typeCalendar"
							:popover="{
								placement: 'bottom',
								visibility: 'click'
							}"
							:input-props="{
								class: 'form-control cal-black',
								style: 'cursor:pointer;'
							}"
							:locale="'es-MX'"
						/>
						<label id="lblmsuser" style="TipoProceso:red" v-if="this.errorvalidacion.FechaInicio" ><Cvalidation :Mensaje="errorvalidacion.FechaInicio[0]" ></Cvalidation ></label>
					</div>
					<div class="col-lg-2" style="flex-basis:13%">
						<label>Inicio *</label>
						<v-date-picker v-model="contract.FechaInicio" :mode="typeCalendar"
							:popover="{
								placement: 'bottom',
								visibility: 'click'
							}"
							:input-props="{
								class: 'form-control cal-black',
								style: 'cursor:pointer;'
							}"
							:locale="'es-MX'"
						/>
						<label id="lblmsuser" style="TipoProceso:red" v-if="this.errorvalidacion.FechaInicio" ><Cvalidation :Mensaje="errorvalidacion.FechaInicio[0]" ></Cvalidation ></label>
					</div>
					<div class="col-lg-2" style="flex-basis:13%">
						<label>Fecha de Termino *</label>
						<v-date-picker v-model="contract.FechaTermino" :mode="typeCalendar"
							:popover="{
								placement: 'bottom',
								visibility: 'click'
							}"
							:input-props="{
								class: 'form-control cal-black',
								style: 'cursor:pointer;'
							}"
						/>
						<label id="lblmsuser" style="TipoProceso:red" v-if="this.errorvalidacion.FechaTermino" ><Cvalidation :Mensaje="errorvalidacion.FechaTermino[0]" ></Cvalidation ></label>
					</div>
					<div class="col-lg-3">
						<label>Vendedor *</label>
						<select v-model="contract.IdUsuario" class="form-control">
							<option value="">Selecciona Vendedor</option>
							<option v-for="(item,index) in ListaVendedores" :value="item.IdUsuario" :key="index">{{item.Nombre}}</option>
						</select>
					</div>
					<!-- <div class="col-lg-2">
						<label for="">Plazo *</label>
						<div class="input-group">
							<input type="text" class="form-control" v-model="contract.Plazo" @input="$onlyNums($event,contract,'Plazo')">
							<select name="" id="" class="form-control w-04" v-model="contract.TipoPlazo">
								<option value="">Seleccione una Opción</option>
								<option value="1">Meses</option>
								<option value="2">Años</option>
							</select>
						</div>
						<label id="lblmsuser" style="TipoProceso:red" v-if="this.errorvalidacion.Plazo" >
							<Cvalidation :Mensaje="errorvalidacion.Plazo[0]" ></Cvalidation >
						</label>
						<label id="lblmsuser" style="TipoProceso:red" v-else-if="this.errorvalidacion.TipoPlazo" >
							<Cvalidation :Mensaje="errorvalidacion.TipoPlazo[0]" ></Cvalidation >
						</label>
					</div> -->
				</div>
				<div v-if="parseInt(contract.Facturacion)>0 && parseInt(contract.Facturacion)<5" class="form-group row">
					<div v-for="(item,index) in ListaDetalles" :key="index" class="col-lg-4 mb-3">
						<div class="row">
							<div class="col-lg-5">
								<label for="">{{'Pago '+(index+1)}}</label>
								<vue-numeric @input="InputValorCopia(index)" class="form-control " currency="$" separator="," placeholder="$0" :precision="0" v-model="item.Monto"></vue-numeric>
							</div>
							<div class="col-lg-7">
								<label for="">Tipo de Pago *</label>
								<select @change="SeleccionPago(index)" v-model="item.TipoPago" class="form-control">
									<option value="">Seleccione un Tipo de Pago</option>
									<option v-for="(jitem,jdex) in item.Lista" :key="jdex" :value="jitem.Valor">{{jitem.Label}}</option>
								</select>
							</div>
						</div>
					</div>
				</div>
				<div class="form-group row" v-else-if="parseInt(contract.Facturacion)==5">
					<div v-for="(item,index) in ListaDetalles" :key="index" class="col-lg-4 mb-3">
						<div class="row">
							<div class="col-lg-5">
								<label for="">{{'Pago '+(index+1)}}</label>
								<vue-numeric class="form-control " currency="$" separator="," placeholder="$0" :precision="0" v-model="item.Monto"></vue-numeric>
							</div>
							<div class="col-lg-7">
								<label for="">Fecha Estimada</label>
								<v-date-picker v-model="item.FechaEstimada" :mode="typeCalendar"
									:popover="{
										placement: 'bottom',
										visibility: 'click'
									}"
									:input-props="{
										class: 'form-control cal-black',
										style: 'cursor:pointer;'
									}"
									:locale="'es-MX'"
								/>
							</div>
						</div>
					</div>
				</div>
				<div class="form-group row" v-else>
					<div v-for="(item,index) in ListaDetalles" :key="index" class="col-lg-4 mb-3">
						<div class="row">
							<div class="col-lg-5">
								<label for="">{{'Pago'}}</label>
								<vue-numeric class="form-control " currency="$" separator="," placeholder="$0" :precision="0" v-model="item.Monto"></vue-numeric>
							</div>
						</div>
					</div>
				</div>
				<div class="form-group row">
					<div class="col-lg-2">
						<label>Gross Profit %</label>
        				<vue-numeric placeholder="0 %"  :minus="false" class="form-control"  currency="" separator="," :precision="0" v-model="contract.GrossProfit"></vue-numeric>
        				<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.GrossProfit" :Mensaje="errorvalidacion.GrossProfit[0]"></Cvalidation></label>
					</div>
				</div>
				<div class="form-group row">
					<div class="col-lg-3">
						<label>Estatus</label>
						<select class="form-control" v-model="contract.Estatus">
							<option value="">Selecciona un Estatus</option>
							<option value="Activo">Activo</option>
							<option value="Inactivo">Inactivo</option>
							<option value="Terminado">Terminado</option>
						</select>
						<!-- <input v-model="contract.Estatus" class="form-control" placeholder="Estatus"/> -->
						<label id="lblmsuser" style="color:red"
							><Cvalidation v-if="this.errorvalidacion.Estatus" :Mensaje="errorvalidacion.Estatus[0]"></Cvalidation
						></label>
					</div>
					<div class="col-lg-3">
						<label>Documento de Confirmación</label>
						<div class="custom-file-input-image">
							<input @change="SubirArchivo()" type="file" accept="application/pdf" ref="file" class="custom-file-input" id="validatedCustomFile" required>
							<input type="text" v-model="NombreArchivo" class="form-control">
							<button type="button" class=""><i class="fas fa-paperclip"></i></button>
						</div>
					</div>
					<div class="col-lg-5">
						<div class="row pt-4">
							<div class="col-lg-6">
								<div class="form-check form-check-inline">
									<label class="check_box m-0 pl-4">
            							<input @change="LimpiarSpendPlan" disabled id="0" v-model="contract.SpendPlan" value="1" type="radio" class="form-check-input">
            							<span class="checkmark" :style="contract.SpendPlan==1 ? 'border:2px solid #bababa;background-color: #038ED9;' : 'border:2px solid #bababa;background-color: grey;'"></span>
            						</label>
									<span class="bold">Spend Plan Automático</span>
								</div>
							</div>
							<div class="col-lg-6">
								<div class="form-check form-check-inline">
									<label class="check_box m-0 pl-4">
            							<input @change="LimpiarSpendPlan" disabled="" id="1" v-model="contract.SpendPlan" value="2" type="radio" class="form-check-input">
            							<span class="checkmark" :style="contract.SpendPlan==2 ? 'border:2px solid #bababa;background-color: #038ED9;' : 'border:2px solid #bababa;background-color: grey;'"></span>
            						</label>
									<span class="bold">Spend Plan Manual</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="form-group row">
					<div class="col-lg-12">
						<label>Comentarios del Contrato</label>
						<textarea v-model="contract.Comentario" placeholder=" Coloque sus comentarios" class="form-control" cols="2" rows="3"
					></textarea>
					</div>
				</div>
				<!-- <div class="col-lg-8">
					<label>Nombre o Numero del Contrato</label>
					<input
						v-model="contract.NumeroC"
						class="form-control"
						placeholder="Nombre"
					/>
					<label id="lblmsuser" style="color:red"
						><Cvalidation
							v-if="this.errorvalidacion.Numero_Contrato"
							:Mensaje="errorvalidacion.Numero_Contrato[0]"
						></Cvalidation
					></label>
				</div>
				<div class="col-lg-8">
					<label for="">Tipo de Contrato</label>
					<select v-model="contract.IdConfigS" class="form-control" name="" id="">
						<option value="">Selecciona una opción</option>
						<option v-for="(lista,index) in ListaTipoServicio" :value=lista.IdConfigS :key="index">
							{{ lista.Nombre }}
						</option>
					</select>
					<label id="lblmsuser" style="color:red"
						><Cvalidation
							v-if="this.errorvalidacion.IdConfigS"
							:Mensaje="errorvalidacion.IdConfigS[0]"
						></Cvalidation
					></label>
				</div>
				<div class="col-lg-8">
					<label>Valor del Contrato</label>
					<vue-numeric
							class="form-control "
							currency="$"
							separator=","
							placeholder="$0.00"
							:precision="2"
							v-model="contract.Valor"
						></vue-numeric>
					<label id="lblmsuser" style="color:red"
						><Cvalidation
							v-if="this.errorvalidacion.Valor"
							:Mensaje="errorvalidacion.Valor[0]"
						></Cvalidation
					></label>
				</div>
				<div class="col-lg-8">
					<label>Comentarios</label>
					<textarea
						v-model="contract.Comentario"
						placeholder=" Coloque sus comentarios"
						class="form-control"
						cols="2"
						rows="3"
					></textarea>
				</div> -->
				<div class="modal-footer f1-buttons mt-4 mx-0 px-0">
					<button :disabled="contract.SpendPlan==''" v-if="contract.IdContrato==0" @click="AbrirContrato(1)" data-toggle="modal" data-target="#Contrato" data-backdrop="static" type="button" class="btn btn-pink">
						<i v-show="poBtnSave.disableBtn" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
						<i class="fa fa-plus-circle"></i>
						Generar Contrato Automático
					</button>
					<button :disabled="contract.SpendPlan==''" v-if="contract.IdContrato==0" @click="AbrirContrato(2)" data-toggle="modal" data-target="#Contrato" data-backdrop="static" type="button" class="btn btn-primary">
						<i v-show="poBtnSave.disableBtn" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
						<i class="fa fa-plus-circle"></i>
						Generar Contrato Manual
					</button>
					<button v-if="contract.IdVenta>0" @click="Guardar" type="button" class="btn btn-01">
						<i v-show="poBtnSave.disableBtn" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
						<i class="fa fa-plus-circle"></i>
						Guardar
					</button>
					<button v-if="contract.IdContrato>0 && contract.IdVenta==null" @click="AbrirContrato(3)" type="button" class="btn btn-01" data-toggle="modal" data-target="#Contrato" data-backdrop="static">
						<i v-show="poBtnSave.disableBtn" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
						<i class="fa fa-plus-circle"></i>
						Generar Spend Plan
					</button>
				</div>
			</template>
		</CLoader>
		<Modal 
            :NameModal="ModalSpendPlan.NameModal" 
            :size="ModalSpendPlan.Size" 
            :Nombre="ModalSpendPlan.Nombre" 
            :pEmitSeccion="ModalSpendPlan.EmitSeccion"
            :poBtnSave="ModalSpendPlan.oBtnSave"
        >
            <template slot="Form">
                <FormPlan :poBtnSave="ModalSpendPlan.oBtnSave"
				:pIdClienteS="contract.IdClienteS"
				:pIdContrato="contract.IdContrato"
				:pIdCliente="pIdCliente"
				:pFecha="contract.FechaInicio"
				:pIdConfigS="contract.IdConfigS"
				:pIdTipoSer="contract.IdTipoSer"></FormPlan>
            </template>
        </Modal>
		<Modal :Showbutton="false" :NameModal="ConfigModalContrato.NameModal"  :size="ConfigModalContrato.Size"  :Nombre="ConfigModalContrato.Nombre"  :pEmitSeccion="ConfigModalContrato.EmitSeccion" :poBtnSave="ConfigModalContrato.oBtnSave">
		<template slot="Form">
			<SpendPlan :pOrigen="'Contratos'"></SpendPlan>
		</template>
		</Modal>
		<Modal :pEmitSeccion="ConfigModalPropuesta.EmitSeccion" :NameModal="ConfigModalPropuesta.NombreSeccion"  :size="ConfigModalPropuesta.Size" :Nombre="'Propuesta'" :poBtnSave="oBtnSavePropuesta">
    		<template slot="Form">
    		    <FormPropuesta :pOrigen="'ventas'" :pIdClienteS="contract.IdClienteS" :NameList="ConfigModalPropuesta.NameForm" :poBtnSave="oBtnSavePropuesta">
    		    </FormPropuesta>
    		</template>
    	</Modal>
	</div>
</template>

<script>
//El props Id es cuando no es modal y se mando con props
//El export de btnsave es por si no se usa el modal
import Cbtnsave from "@/components/Cbtnsave.vue";
import Cvalidation from "@/components/Cvalidation.vue";
import Modal from '@/components/Cmodal.vue';
import FormPlan from '../contratos/FormPlan.vue';
import FormPropuesta from '../contratos/FormPropuesta.vue';
import SpendPlan from '@/views/modulos/ventas/ContratoForm.vue';
export default {
	name: "Form",
	props: ["IdContrato", "pIdClienteS", "NameList", "poBtnSave","pIdCliente"],
	data() {
		return {
			Modal: true, //Sirve pra los botones de guardado
			FormName: "cliente", //Sirve para donde va regresar
			ConfigLoad:{
				ShowLoader:true,
				ClassLoad:true
			},
			contract: {
				IdContrato: 0,
				IdClienteS: 0,
				IdCliente:0,
				NumeroC: "",
				Comentario: "",
				IdProyectoSpend: 0,
				IdConfigS:"",
				Valor:"",
				TipoContrato:"",
				FechaInicio:"",
				FechaVenta:"",
				FechaTermino:"",
				Facturacion:"",
				Archivo:"",
				Estatus:"",
				IdTipoSer:"",
				GrossProfit:0,
				Plazo:"",
				TipoPlazo:"",
				IdUsuario:"",
				IdCotizacionServicio:'',
				IdPropuesta:"",
				SpendPlan:'',
				ValorPropuesta:'',
				ContratoMaster:false,
				IdContratoMaster:''
			},
			EmitSeccion:this.poBtnSave.EmitSeccion,
			errorvalidacion: [],
			checked: false,
			checkedScanning: false,
			ListaContratos: [],
			ListaTipoServicio:[],
			ListaSubTipoServicio:[],
			ListaVendedores:[],
			ListaPropuestas:[],
			SpendPlan:[],
			ListaDetalles:[],
			ListaDetallesCopia:[],
			NombreArchivo:"Elegir Archivo (0.5MB)",
			ConfigModalContrato:{
				NameModal:'Contrato',
				Size:'modal-md',
				Nombre:'Contrato',
				EmitSeccion:'Contrato',
				oBtnSave:{
					isModal:true,
                    disableBtn:false,
                	toast:0,
                	nombreModal:"Contrato",
                	EmitSeccion:"Contrato"
				}
			},
			ModalSpendPlan:{
				NameModal:'SpendPlan',
				Size:'modal-lg',
				Nombre:'Spend Plan',
				EmitSeccion:'SpendPlan',
				oBtnSave:{
					isModal:true,
                    disableBtn:false,
                	toast:0,
                	nombreModal:"SpendPlan",
                	EmitSeccion:"SpendPlan"
				}
			},
			ConfigModalPropuesta:{
                NombreSeccion:"PropuestaContrato",
                EmitSeccion:"PropuestaContrato",
                Size:"modal-lg",
                Nombre:"PropuestaContrato",
                NameForm:"PropuestaContrato",
            },
			oBtnSavePropuesta:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"PropuestaContrato",
                EmitSeccion:"PropuestaContrato"
            },
			DisableCampos:false,
			ListaContratosMaster:[]
			// EmitSeccion:this.poBtnSave.EmitSeccion
		};
	},
	components: {
		Cbtnsave,
		Cvalidation,
		Modal,
		FormPlan,
		SpendPlan,
		FormPropuesta
	},
	methods: {
		async Guardar() {
			//deshabilita botones
			let Operacion="";
			if (this.contract.IdContrato=="" ? Operacion="Crear" : Operacion="Editar");
			this.poBtnSave.toast = 0;
			this.poBtnSave.disableBtn = true;
			let FechaInicio='';
			let FechaTermino='';
			let FechaVenta='';
			let archivo=this.$refs.file.files[0];
			if (this.contract.FechaVenta !='' && this.contract.FechaVenta!=undefined) {
				let day=this.contract.FechaVenta.getDate();
                let month=this.contract.FechaVenta.getMonth()+1;
                let year=this.contract.FechaVenta.getFullYear();
                FechaVenta=year+'-'+month+'-'+day;
			}
			if (this.contract.FechaInicio !='' && this.contract.FechaInicio!=undefined) {
				let day=this.contract.FechaInicio.getDate();
                let month=this.contract.FechaInicio.getMonth()+1;
                let year=this.contract.FechaInicio.getFullYear();
                FechaInicio=year+'-'+month+'-'+day;
			}
			if (this.contract.FechaTermino !='' && this.contract.FechaTermino!=undefined) {
				let day=this.contract.FechaTermino.getDate();
                let month=this.contract.FechaTermino.getMonth()+1;
                let year=this.contract.FechaTermino.getFullYear();
                FechaTermino=year+'-'+month+'-'+day;
			}
			let formData=new FormData();
			formData.set('IdContrato',this.contract.IdContrato);
			formData.set('IdCliente',this.contract.IdCliente);
			formData.set('IdClienteS',this.contract.IdClienteS);
			formData.set('NumeroC',this.contract.NumeroC);
			formData.set('Comentario',this.contract.Comentario);
			formData.set('IdProyectoSpend',this.contract.IdProyectoSpend);
			formData.set('IdConfigS',this.contract.IdConfigS);
			formData.set('IdTipoSer',this.contract.IdTipoSer);
			formData.set('Valor',this.contract.Valor);
			formData.set('TipoContrato',this.contract.TipoContrato);
			formData.set('ContratoAuto',this.TipoContrato);
			formData.set('FechaInicio',FechaInicio);
			formData.set('FechaVenta',FechaVenta);
			formData.set('FechaTermino',FechaTermino);
			// formData.set('Plazo',this.contract.Plazo);
			// formData.set('TipoPlazo',this.contract.TipoPlazo);
			formData.set('Facturacion',this.contract.Facturacion);
			formData.set('Archivo',this.contract.Archivo);
			formData.append('ArchivoFile',archivo);
			formData.set('Estatus',this.contract.Estatus);
			formData.set('GrossProfit',this.contract.GrossProfit);
			formData.set('IdUsuario',this.contract.IdUsuario);
			formData.set('IdPropuesta',this.contract.IdPropuesta);
			formData.set('ValorPropuesta',this.contract.ValorPropuesta);
			formData.set('ContratoMaster',this.contract.ContratoMaster ? 1 : 0);
			formData.set('IdContratoMaster',this.contract.IdContratoMaster);
			formData.set('SpendPlan',this.contract.SpendPlan);
			formData.set('SpendPlanDetalle',JSON.stringify(this.SpendPlan));
			if (this.contract.Facturacion==5) {
				let Detalles=[];
				for (let i = 0; i < 6; i++) {
					if (this.ListaDetalles[i].FechaEstimada!='') {
						let FechaEstimada='';
						if (this.ListaDetalles[i].FechaEstimada !='' && this.ListaDetalles[i].FechaEstimada!=undefined) {
							let day=this.ListaDetalles[i].FechaEstimada.getDate();
            			    let month=this.ListaDetalles[i].FechaEstimada.getMonth()+1;
            			    let year=this.ListaDetalles[i].FechaEstimada.getFullYear();
            			    FechaEstimada=year+'-'+month+'-'+day;
						}
						let Obj={Monto:this.ListaDetalles[i].Monto,FechaEstimada:FechaEstimada}
						Detalles.push(Obj);
					}
				}
				formData.set('Detalles',JSON.stringify(Detalles));	
			}
			else{
				let EnArray=['1','2','3','4'];
				if (EnArray.includes(this.contract.Facturacion)) {
					let Bnd=false;
					this.ListaDetalles.forEach((value) => {
						if (value.TipoPago=='') {
							Bnd=true;
						}
					})
					if(Bnd){
						this.poBtnSave.disableBtn=false;
						this.bus.$emit('EnableBtnContrato');
						this.$toast.warning('Favor de Colocar un Tipo de Pago');
						return false;
					}	
				}
				formData.set('Detalles',JSON.stringify(this.ListaDetalles));
			}
			// formData.set('TipoContrato',this.TipoContrato);
			this.$http.post("numcontrato/post", formData)
				.then(res => {
					if (this.contract.IdContrato==0) {
						// MODIFICAR LA VARIABLE DE SESION PARA QUE HAYA CONCORDANCIA
						if (JSON.parse(sessionStorage.getItem("IdSaved")).Contratos!=null) {
							let Obj=JSON.parse(sessionStorage.getItem("IdSaved"));
							Obj.Contratos++;
							sessionStorage.setItem("IdSaved",JSON.stringify(Obj));
						}	
					}
					this.poBtnSave.disableBtn = false;
					this.poBtnSave.toast = 1;
					this.bus.$emit('EnableBtnContrato');
					this.$toast.success("Contrato Guardado");
					$('#Contrato').modal('hide');
					$("#Contratos").modal("hide");
					this.bus.$emit("List",Operacion,"Contrato");
				})
				.catch(err => {
					this.bus.$emit('EnableBtnContrato');
					this.errorvalidacion = err.response.data.message.errores;
					this.poBtnSave.disableBtn = false;
					this.poBtnSave.toast = 2;
				});
		},
		Limpiar() {
			$('#Contratos > .modal-dialog > .modal-content > .modal-header > #exampleModalLabel').text('Contratos');
			this.contract = {
				IdContrato: 0,
				IdCliente:0,
				IdClienteS: 0,
				NumeroC: "",
				Comentario: "",
				IdProyectoSpend: 0,
				IdConfigS:"",
				Valor:"",
				TipoContrato:"",
				FechaVenta:new Date(),
				FechaInicio:new Date(),
				FechaTermino:"",
				Facturacion:"",
				Archivo:"",
				Estatus:"",
				IdTipoSer:"",
				GrossProfit:0,
				Plazo:"",
				TipoPlazo:"",
				IdUsuario:"",
				IdCotizacionServicio:'',
				IdPropuesta:'',
				SpendPlan:'',
				ValorPropuesta:'',
				ContratoMaster:false,
				IdContratoMaster:''
			};
			this.errorvalidacion = [""];
			this.NombreArchivo="Elegir Archivo (0.5MB)";
			this.ListaVendedores=[];
			this.ListaPropuestas=[];
			this.ListaDetalles=[];
			this.ListaDetallesCopia=[];
			this.ListaContratosMaster=[];
		},
		LimpiarSpendPlan(){
			this.SpendPlan=[];
		},
		get_one() {
			this.$http
				.get("numcontrato/recovery", {
					params: { IdContrato: this.contract.IdContrato }
				})
				.then(res => {
					this.contract = res.data.data.contrato;
					this.contract.GrossProfit=res.data.data.contrato.GP==null ? res.data.data.contrato.GrossProfit : res.data.data.contrato.GP;
					this.contract.ValorPropuesta=res.data.data.contrato.ValorPropuesta==null ? '' : res.data.data.contrato.ValorPropuesta ;
					if (res.data.data.contrato.FechaInicio!=null) {
						let formatedDateInicio=res.data.data.contrato.FechaInicio.replace(/-/g, "\/");
						this.contract.FechaInicio=new Date(formatedDateInicio);	
					}
					if (res.data.data.contrato.FechaTermino!=null) {
						let formatedDateTermino=res.data.data.contrato.FechaTermino.replace(/-/g, "\/");
						this.contract.FechaTermino=new Date(formatedDateTermino);	
					}
					if (res.data.data.contrato.FechaVenta!=null) {
						let formatedDateVenta=res.data.data.contrato.FechaVenta.replace(/-/g, "\/");
						this.contract.FechaVenta=new Date(formatedDateVenta);	
					}
					this.contract.ContratoMaster=res.data.data.contrato.ContratoMaster==0 || res.data.data.contrato.ContratoMaster==null? false : true;
					this.contract.IdContratoMaster=res.data.data.contrato.IdContratoMaster;
					this.NombreArchivo=res.data.data.contrato.Archivo;
					this.ListaDetalles=res.data.data.detalles;
					this.contract.IdCliente=this.pIdCliente;
					$('#Contratos > .modal-dialog > .modal-content > .modal-header > #exampleModalLabel').text(this.contract.NumeroC);
					if (this.contract.Facturacion!=5) {
						for (let index = 0; index < this.ListaDetalles.length; index++) {
							this.ListaDetalles[index].Lista=[
								{Valor:'1',Label:'Anticipo'},
								{Valor:'2',Label:'Contado'},
								{Valor:'3',Label:'Contraentrega'},
								{Valor:'4',Label:'30 días'},
								{Valor:'5',Label:'60 días'},
								{Valor:'6',Label:'90 días'}
							];
						}	
					}
					else{
						for (let index = 0; index < 6; index++){
							if (typeof(this.ListaDetalles[index])==='undefined') {
								this.ListaDetalles.push({Monto:0,FechaEstimada:''})
							}
							else{
								let Fecha = this.ListaDetalles[index].FechaEstimada.replace(/-/g, "\/");
								this.ListaDetalles[index].FechaEstimada=new Date(Fecha);
							}
						}
					}
					this.ListaDetallesCopia=this.ListaDetalles;
					this.ListaSubtipo();
					this.GetPropuestas();
					this.SetCasillaSpendPlan();
				}).finally(()=>{
					this.ConfigLoad.ShowLoader=false;
				});
		},
		AbrirContrato(TipoContrato){
			this.bus.$emit('SetContrato',this.contract.NumeroC,this.contract.IdConfigS,TipoContrato,this.contract.SpendPlan,this.contract.IdCotizacionServicio,this.contract.Valor);
		},
		SetListaDetalles(){
			this.ListaDetalles=[];
			this.ListaDetallesCopia=[];
			if (this.contract.Facturacion<5) {
				let Veces=parseInt(this.contract.Facturacion);
				for (let index = 0; index < Veces; index++) {
					if (Veces==1) {
						this.ListaDetalles.push({Monto:this.contract.Valor,TipoPago:'',Lista:[
								{Valor:'1',Label:'Anticipo'},
								{Valor:'3',Label:'Contraentrega'},
								{Valor:'4',Label:'30 días'},
								{Valor:'5',Label:'60 días'},
								{Valor:'6',Label:'90 días'}
							]});
							this.ListaDetallesCopia.push({Monto:this.contract.Valor,TipoPago:'',Lista:[
								{Valor:'1',Label:'Anticipo'},
								{Valor:'3',Label:'Contraentrega'},
								{Valor:'4',Label:'30 días'},
								{Valor:'5',Label:'60 días'},
								{Valor:'6',Label:'90 días'}
							]});
					}
					else{
						this.ListaDetalles.push({Monto:0,TipoPago:'',Lista:[
							{Valor:'1',Label:'Anticipo'},
							{Valor:'3',Label:'Contraentrega'},
							{Valor:'4',Label:'30 días'},
							{Valor:'5',Label:'60 días'},
							{Valor:'6',Label:'90 días'}
						]});
						this.ListaDetallesCopia.push({Monto:0,TipoPago:'',Lista:[
							{Valor:'1',Label:'Anticipo'},
							{Valor:'3',Label:'Contraentrega'},
							{Valor:'4',Label:'30 días'},
							{Valor:'5',Label:'60 días'},
							{Valor:'6',Label:'90 días'}
						]});
					}
				}	
			}
			else if (this.contract.Facturacion==5){
				for (let index = 0; index < 6; index++){
					this.ListaDetalles.push({Monto:0,FechaEstimada:''});
				}
			}
			else{
				this.ListaDetalles.push({Monto:0,TipoPago:''})
			}
		},
		InputValorCopia(IndexSeleccion){
			this.ListaDetallesCopia[IndexSeleccion].Monto=this.ListaDetalles[IndexSeleccion].Monto;
		},
		SeleccionPago(IndexSeleccion){
			this.ListaDetallesCopia[IndexSeleccion].TipoPago=this.ListaDetalles[IndexSeleccion].TipoPago;
			this.ListaDetalles=JSON.parse(JSON.stringify(this.ListaDetallesCopia));
			let Index30Dias=this.ListaDetalles.findIndex((value) => value.TipoPago=='4');
			let Index60Dias=this.ListaDetalles.findIndex((value) => value.TipoPago=='5');
			let Index90Dias=this.ListaDetalles.findIndex((value) => value.TipoPago=='6');
			let IndexAnticipo=this.ListaDetalles.findIndex((value) => value.TipoPago=='1');
			// console.log(Index30Dias);
			// console.log(Index60Dias);
			// console.log(Index90Dias);
			for (let i = 0; i < this.ListaDetalles.length; i++) {
				if (Index30Dias!=-1) {
					if (i!=Index30Dias) {
						this.ListaDetalles[i].Lista.splice(2,1);
					}
				}
				if (Index60Dias!=-1) {
					if (Index30Dias!=-1) {
						if (i!=Index60Dias && i!=Index30Dias) {
							this.ListaDetalles[i].Lista.splice(2,1);	
						}
					}
					else{
						if (i!=Index60Dias) {
							this.ListaDetalles[i].Lista.splice(3,1);
						}
					}
				}
				if (Index90Dias!=-1) {
					// console.log(Index30Dias);
					if (i!=Index90Dias) {
						this.ListaDetalles[i].Lista.splice(4,1);
						if (i!=Index30Dias && i!=Index60Dias) {
							this.ListaDetalles[i].Lista.splice(2,2);
						}
						if (Index60Dias!=-1 && Index60Dias>Index90Dias) {
							this.ListaDetalles[Index60Dias].TipoPago='';
						}
					}
				}
				if (IndexAnticipo!=-1 && this.ListaDetalles[i].TipoPago!='1') {
					this.ListaDetalles[i].Lista.splice(0,1);
				}
				let Mapeado=this.ListaDetalles[i].Lista.map((value) => {return value.Valor});
				if (!Mapeado.includes(this.ListaDetalles[i].TipoPago)) {
					this.ListaDetalles[i].TipoPago='';
				}
			}
		},
		async GetPropuestas(Propuesta=null){
			await this.$http.get('propuestas/get',{
				params:{
					RegEstatus:'A',
					IdClienteS:this.contract.IdClienteS,
					Estatus:this.contract.IdVenta==null ? 'Activa' : ''
				}
			}).then((res)=>{
				this.ListaPropuestas=res.data.data.todos;
				// console.log(this.Venta.IdPropuesta);
			}).finally(()=>{
				if (Propuesta!=null) {
					this.ValoresPropuesta();
				}
			})
		},
		ValoresPropuesta(){
			if (this.contract.IdPropuesta=='0') {
				this.DisableCampos=false;
				this.contract.IdCotizacionServicio='';
				this.SetCasillaSpendPlan();
				return false;
			}
			if (this.contract.IdPropuesta=='crear') {
				$("#PropuestaContrato").modal("show");
				this.bus.$emit('NewModal_'+this.ConfigModalPropuesta.EmitSeccion,0,0,this.ObjPropiedad,this.contract.IdClienteS);
			}
			else{
				this.DisableCampos=true;
				let index=this.ListaPropuestas.findIndex((element)=>element.IdPropuesta==this.contract.IdPropuesta);
				this.contract.ValorPropuesta=this.ListaPropuestas[index].Valor;
				this.contract.Valor=this.ListaPropuestas[index].Valor;
				this.contract.IdConfigS=this.ListaPropuestas[index].Tipo;
				this.contract.IdCotizacionServicio=this.ListaPropuestas[index].IdCotizacionServicio;
				this.contract.GrossProfit=this.ListaPropuestas[index].GrossProfit==null ? '' : this.ListaPropuestas[index].GrossProfit;
				this.contract.Comentario=this.ListaPropuestas[index].DescripcionPropuesta;
				if (this.ListaPropuestas[index].IdTipoSer!='') {
					this.contract.IdTipoSer=this.ListaPropuestas[index].IdTipoSer;
				}
				this.ListaSubtipo();
				this.SetCasillaSpendPlan();
			}
		},
		ListTipoContrato(){
			this.$http.get("configservicio/get",
			{
				params:
				{
					RegEstatus:"A"
				}
			}).then((res)=>{
				this.ListaTipoServicio=res.data.data.configservicio
			})
		},
		async ListaSubtipo() {
			await this.$http.get('tiposervicio/get',{
				params:{
					RegEstatus:'A',
					IdConfigS:this.contract.IdConfigS,
					// IdTipoServ:this.contract.IdTipoServ,
					Entrada:''
				}
			}).then( (res) => {
				this.ListaSubTipoServicio =res.data.data.tiposervicio;
			});
		},
		SubirArchivo(){
			const image = this.$refs.file.files[0];

            var FileSize = image.size / 1024 / 1024; // in MB
            if (FileSize > 0.5) {
                this.$toast.info('Solo se puede subir archivos menores a 0.5 MB');
                const  input  = this.$refs.file;
                input .type = 'text'
                input .type = 'file';
                return false;
            }
                        
            var allowedExtensions = /(\.pdf|\.PDF)$/i;
            if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extenciones permitidas .pdf');
                const  input  = this.$refs.file;
                input.type = 'text'
                input.type = 'file';
                this.NombreArchivo='Elegir archivo (0.5MB)';
                return false;
            }

            this.NombreArchivo=image.name;
		},
		LimitarGrossProfit(){
			if (parseInt(this.contract.GrossProfit)>100) {
				this.contract.GrossProfit='0';
			}
		},
		AbrirPlan(){
			this.bus.$emit("NewModal_"+this.ModalSpendPlan.EmitSeccion,true);
		},
		async GetVendedor(){
			await this.$http.get('vendedores/get', {
                params: { RegEstatus: "A",Admin:1 },
            })
            .then((res) => {
                let Mapeado=res.data.data.Vendedores.map((Element)=>{
                    if (Element.IdUsuario==null) {
                        Element.IdUsuario=Element.TrabajadorUsuario,
                        Element.Nombre=Element.NombreAdmin
                        return Element;
                    }
                    else{
                        return Element;
                    }
                });
                this.ListaVendedores=Mapeado;
            });
		},
		SetCasillaSpendPlan(){
			if (this.contract.IdConfigS=="1" || this.contract.IdConfigS=="3") {
				this.contract.SpendPlan="2";
			}
			else if(this.contract.IdConfigS=="2" && this.contract.IdCotizacionServicio==""){
				this.contract.SpendPlan="2";
			}
			else{
				this.contract.SpendPlan="1";
			}
			this.LimpiarSpendPlan();
		},
		GetContratosMaster(){
			this.$http.get('numcontratoadicional/get',{
				params:{
					IdClienteS:this.contract.IdClienteS
				}
			}).then((res)=>{
				this.ListaContratosMaster=res.data.data.row;
			});
		},
		SugerenciaVenta(){
            // this.Activo.CodigoActivo=this.CodigoActivo;
			// console.log(this.Venta.ValorPropuesta);
			let ValorPropuesta=this.contract.ValorPropuesta.toString();
            let substr=ValorPropuesta.substring(0,(ValorPropuesta.length)-1);
            let pattern=new RegExp(substr,"gi");
        
            if (pattern.test(this.contract.Valor)) {
                this.contract.Valor=this.contract.ValorPropuesta;
            }
        },
		SugerenciaPegado(event){
            // console.log(event.clipboardData.getData('text/plain'));
            this.contract.Valor=event.clipboardData.getData('text/plain');
        },
	},
	created() {
		this.ListTipoContrato();
		this.bus.$off("NewModal_"+this.EmitSeccion);

		
	},
	beforeDestroy() {
		this.bus.$off("NewModal_"+this.EmitSeccion);
	},
	mounted() {
		//Este es para modal
		this.bus.$on("NewModal_"+this.EmitSeccion, (data, Id) => {
			this.ConfigLoad.ShowLoader=true;
			this.Limpiar();
			this.GetVendedor();
			this.contract.IdClienteS = this.pIdClienteS;
			this.contract.IdCliente = this.pIdCliente;
			this.GetPropuestas();

			this.poBtnSave.disableBtn = false;
			this.bus.$off("Save_"+this.EmitSeccion);
			this.bus.$on("Save_"+this.EmitSeccion, (Contrato,SpendPlan,TipoContrato,GPPlanPorcent) => {
				this.contract.NumeroC=Contrato;
				this.SpendPlan=SpendPlan;
				// this.contract.GrossProfit=GPPlanPorcent;
				if (this.contract.SpendPlan==1) {
					if (this.contract.IdCotizacionServicio>0) {
						this.contract.GrossProfit=GPPlanPorcent;
					}
				}
				this.TipoContrato=TipoContrato;
				this.Guardar();
			});

			if (Id > 0) {
				this.contract.IdContrato = Id;
				this.get_one();
			}
			else{
				this.contract.IdUsuario=JSON.parse(sessionStorage.getItem("user")).IdUsuario;
				this.ConfigLoad.ShowLoader=false;
			}

			this.ListaContratos = [];

			this.bus.$emit("Desbloqueo", false);
			this.GetContratosMaster();
		});
		this.bus.$off('AsignarPropuesta');
		this.bus.$on('AsignarPropuesta',(Propuesta)=>{
			// console.log(Propuesta);
			this.contract.IdPropuesta=Propuesta.propuesta.IdPropuesta;
			this.GetPropuestas(Propuesta);
		});
		this.bus.$off('GuardarSpendPlan');
		this.bus.$on('GuardarSpendPlan',(SpendPlan)=>{
			this.SpendPlan=SpendPlan;
			// console.log(this.SpendPlan);
		});
	},
	computed:{
		typeCalendar: function() {
			return "single";
		},
	}
};
</script>
